import * as Yup from 'yup';

export default Yup.object().shape({
  serialNumber: Yup.string().nullable(),
  purchaseDate: Yup.date()
    .nullable()
    .typeError('SCHEMA_ERRORS.DATE_MUST_BE_VALID'),
  moreInfo: Yup.string().nullable()
});
